import { css } from '@emotion/css';

export const articleCx = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: justify;

  ol {
    margin-top: 0;
    margin-bottom: 16px;

    li:not(:last-child) {
      margin-bottom: 12px;
    }
  }
`;
